import { gql } from '@apollo/client';

export const SAVE_USER_GROUP = gql`
  mutation saveUserGroup($input: UserGroupInput!) {
    saveUserGroup(input: $input) {
      commandId
      correlationId
    }
  }
`;

export const SAVE_USER_X_GROUP = gql`
  mutation saveUserXGroup($input: UserXGroupInput!) {
    saveUserXGroup(input: $input) {
      commandId
      correlationId
    }
  }
`;

export const DELETE_USER_X_GROUP = gql`
  mutation deleteUserXGroup($userGroupId: Int!, $userId: Int!) {
    deleteUserXGroup(userGroupId: $userGroupId, userId: $userId) {
      commandId
      correlationId
    }
  }
`;
